import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import axios from "axios";
import { MdWavingHand } from "react-icons/md";
import welcomeUser from "../images/profile/user_welcome.png";
import { buildApiUrl } from "../utils/api";

function UserDetails() {
    const [userName, setUserName] = useState("");

    useEffect(() => {
        const fetchUserDetails = async () => {
            try {
                const token = localStorage.getItem("token");
                if (!token) return;

                const res = await axios.get(buildApiUrl("/api/user/details"), {
                    headers: { Authorization: `Bearer ${token}` }
                });

                if (res.data?.user) {
                    setUserName(res.data.user.name || "");
                }
            } catch (error) {
                console.error("Error fetching user details", error);
            }
        };
        fetchUserDetails();
    }, []);

    return (
        <>
            <Helmet>
                <title>My Dashboard | 3PL Search</title>
            </Helmet>
            <div className="userhead p-3">
                <h2>Welcome, {userName || "Buyer"} <MdWavingHand style={{ color: "#E0A75E" }} /></h2>
                <p className="text-muted mb-4">Find and compare 3PL warehouses, track your quote requests, and manage your saved shortlist.</p>

                <div className="row g-3 mb-4">
                    <div className="col-sm-6 col-md-4">
                        <Link to="/userDetails/bookingList" style={{ textDecoration: "none" }}>
                            <div className="card h-100 border-0 shadow-sm p-3 text-center">
                                <h5 style={{ color: "#132238" }}>My Quote Requests</h5>
                                <p className="text-muted small">Track the status of warehouse quote requests you have submitted.</p>
                            </div>
                        </Link>
                    </div>
                    <div className="col-sm-6 col-md-4">
                        <Link to="/userDetails/userWishList" style={{ textDecoration: "none" }}>
                            <div className="card h-100 border-0 shadow-sm p-3 text-center">
                                <h5 style={{ color: "#132238" }}>Saved Warehouses</h5>
                                <p className="text-muted small">Review warehouses you have saved to your shortlist.</p>
                            </div>
                        </Link>
                    </div>
                    <div className="col-sm-6 col-md-4">
                        <Link to="/finder" style={{ textDecoration: "none" }}>
                            <div className="card h-100 border-0 shadow-sm p-3 text-center">
                                <h5 style={{ color: "#132238" }}>Browse Directory</h5>
                                <p className="text-muted small">Explore our global directory of 3PL providers and request quotes.</p>
                            </div>
                        </Link>
                    </div>
                </div>

                <div className="text-center" style={{ opacity: 0.5, maxWidth: "360px" }}>
                    <img src={welcomeUser} alt="welcome" style={{ width: "100%" }} />
                </div>
            </div>
        </>
    );
}

export default UserDetails;
